const dashboard = {
    oldUrl: '#',
    oldPath: '/',
    newUrlPath: '/cloud-soar-dashboard'
};
const incidents = {
    oldUrl: '#ir',
    oldPath: '/ir',
    newUrlPath: '/cases'
};

//RN TODO Not in doc
const incidentsCreation = {
    oldUrl: '#incident-creation',
    oldPath: '/incident-creation',
    newUrlPath: '/case-creation'
};
const incidentsDetails = {
    oldUrl: '#incident|:id|details',
    oldPath: '/incident|:id|details',
    newUrlPath: '/cases/:id/details'
};
const incidentsPlaybooks = {
    oldUrl: '#incident|:id|playbook',
    oldPath: '/incident|:id|playbook',
    newUrlPath: '/cases/:id/playbooks'
};
const incidentPlaybookExecution = {
    oldUrl: '#incident|:section|playbook|:id',
    oldPath: '/incident|:section|playbook|:id',
    newUrlPath: '/cases/:section/playbooks/:id'
};
const incidentsTasks = {
    oldUrl: '#incident|:id|tasks',
    oldPath: '/incident|:id|tasks',
    newUrlPath: '/cases/:id/tasks'
};
const incidentsNotes = {
    oldUrl: '#incident|:id|notes',
    oldPath: '/incident|:id|notes',
    newUrlPath: '/cases/:id/notes'
};
const incidentsObjects = {
    oldUrl: '#incident|:id|objects',
    oldPath: '/incident|:id|objects',
    newUrlPath: '/cases/:id/objects'
};
const incidentsAttachments = {
    oldUrl: '#incident|:id|attachments',
    oldPath: '/incident|:id|attachments',
    newUrlPath: '/cases/:id/attachments'
};
const triage = {
    oldUrl: '#triage',
    oldPath: '/triage',
    newUrlPath: '/triage'
};
const triageDetails = {
    oldUrl: '#triage|:id',
    oldPath: '/triage|:id',
    newUrlPath: '/triage/:id'
};
const entities = {
    oldUrl: '#entities',
    oldPath: '/entities',
    newUrlPath: '/cloud-soar-entities'
};
const entitiesDetails = {
    oldUrl: '#entities|:section|:id',
    oldPath: '/entities|:section|:id',
    newUrlPath: '/cloud-soar-entities/:id'
};
const reports = {
    oldUrl: '#report',
    oldPath: '/report',
    newUrlPath: '/reports'
};
const reportsDetails = {
    oldUrl: '#report|:id',
    oldPath: '/report|:id',
    newUrlPath: '/reports/:id'
};
const appCentral = {
    oldUrl: '#app_central',
    oldPath: '/app_central',
    newUrlPath: '/automation-apps'
};
const appCentralExport = {
    oldUrl: '#app_central_export',
    oldPath: '/app_central_export',
    newUrlPath: '/automation-apps-export'
};
const playbooks = {
    oldUrl: '#playbook',
    oldPath: '/playbook',
    newUrlPath: '/playbooks'
};
const playbookExecutions = {
    oldUrl: '#playbook-executions',
    oldPath: '/playbook-executions',
    newUrlPath: '/playbook-executions'
};
const playbooksDetails = {
    oldUrl: '#playbook|:id',
    oldPath: '/playbook|:id',
    newUrlPath: '/playbooks/:id'
};
const templates = {
    oldUrl: '#template_wizard',
    oldPath: '/template_wizard',
    newUrlPath: '/case-templates'
};
const templatesDetails = {
    oldUrl: '#template_wizard|:id',
    oldPath: '/template_wizard|:id',
    newUrlPath: '/case-templates/:id'
};
const integrations = {
    oldUrl: '#3rd_party_integrations',
    oldPath: '/3rd_party_integrations',
    newUrlPath: '/automation-integrations'
};
const integrationsDetails = {
    oldUrl: '#3rd_party_integrations|:id',
    oldPath: '/3rd_party_integrations|:id',
    newUrlPath: '/automation-integrations/:id'
};
const rules = {
    oldUrl: '#setting_integration_rules',
    oldPath: '/setting_integration_rules',
    newUrlPath: '/cloud-soar-rules'
};
const rulesDetails = {
    oldUrl: '#setting_integration_rules|:id',
    oldPath: '/setting_integration_rules|:id',
    newUrlPath: '/cloud-soar-rules/:id'
};
const bridges = {
    oldUrl: '#bridge',
    oldPath: '/bridge',
    newUrlPath: '/bridges'
};
const fields = {
    oldUrl: '#setting_user_interface',
    oldPath: '/setting_user_interface',
    newUrlPath: '/cloud-soar-fields'
};
const fieldsDetails = {
    oldUrl: '#setting_user_interface|:id',
    oldPath: '/setting_user_interface|:id',
    newUrlPath: '/cloud-soar-fields/:id'
};
const incidentLabels = {
    oldUrl: '#setting_label',
    oldPath: '/setting_label',
    newUrlPath: '/case-labels'
};
const triageSettings = {
    oldUrl: '#setting_triage',
    oldPath: '/setting_triage',
    newUrlPath: '/triage-settings'
};
const general = {
    oldUrl: '#setting_general',
    oldPath: '/setting_general',
    newUrlPath: '/cloud-soar-settings'
};

const generalSystem = {
    oldUrl: '#setting_general|system',
    oldPath: '/setting_general|system',
    newUrlPath: '/cloud-soar-settings'
};

const incidentsSettings = {
    oldUrl: '#setting_general|incidents',
    oldPath: '/setting_general|incidents',
    newUrlPath: '/case-settings'
};

//RN TODO added but not in doc
const generalSettings = {
    oldUrl: '#general-settings',
    oldPath: '/general-settings',
    newUrlPath: '/cloud-soar-settings'
};
const groups = {
    oldUrl: '#groups_management',
    oldPath: '/groups_management',
    newUrlPath: '/cloud-soar-groups'
};
const groupsDetails = {
    oldUrl: '#groups_management|:id',
    oldPath: '/groups_management|:id',
    newUrlPath: '/cloud-soar-groups/:id'
};
const notifications = {
    oldUrl: '#setting_notification',
    oldPath: '/setting_notification',
    newUrlPath: '/cloud-soar-notifications'
};
//TODO RN not in the document but in GUI (?)
const logo = {
    oldUrl: '#setting_logo',
    oldPath: '/setting_logo',
    newUrlPath: '/setting_logo'
};
const preferences = {
    oldUrl: '#preferences',
    oldPath: '/preferences',
    newUrlPath: '/preferences'
};
const automationServicePlaybookExecution = {
    oldUrl: '#automation-service|:id',
    oldPath: '/automation-service|:id',
    newUrlPath: '/automation-service/:id'
};

const training = {
    oldUrl: '#training',
    oldPath: '/training',
    newUrlPath: '/training'
};

//RN: oldUrl is the URL reached by href, oldPath is old routing path, newUrlPath is used for new routing,
// without use of href, due to entire page refresh
const oldNewRoutingSchemaObj = {
    dashboard,
    incidents,
    incidentsCreation,
    incidentsDetails,
    incidentsPlaybooks,
    incidentPlaybookExecution,
    incidentsObjects,
    incidentsAttachments,
    incidentsNotes,
    incidentsTasks,
    triage,
    triageDetails,
    entities,
    entitiesDetails,
    reports,
    reportsDetails,
    appCentral,
    appCentralExport,
    playbooks,
    playbookExecutions,
    playbooksDetails,
    templates,
    templatesDetails,
    integrations,
    integrationsDetails,
    rules,
    rulesDetails,
    bridges,
    incidentsSettings,
    fields,
    fieldsDetails,
    incidentLabels,
    triageSettings,
    general,
    generalSystem,
    generalSettings,
    groups,
    groupsDetails,
    notifications,
    logo,
    preferences,
    automationServicePlaybookExecution,
    training
};

const oldNewRoutingSchemaArray = [
    dashboard,
    incidents,
    incidentsCreation,
    incidentsDetails,
    triage,
    triageDetails,
    entities,
    entitiesDetails,
    reports,
    reportsDetails,
    appCentral,
    appCentralExport,
    playbooks,
    playbookExecutions,
    playbooksDetails,
    templates,
    templatesDetails,
    integrations,
    integrationsDetails,
    rules,
    rulesDetails,
    bridges,
    incidentsSettings,
    fields,
    fieldsDetails,
    incidentLabels,
    triageSettings,
    general,
    generalSystem,
    generalSettings,
    groups,
    groupsDetails,
    notifications,
    logo,
    preferences,
    automationServicePlaybookExecution,
    training
];

/* RN: return specific path of a section
param @key - String - desired key of oldNewRoutingSchemaObj
param @path - String - one of [oldUrl, oldPath, newUrlPath]
 */
const returnSpecificPath = (key, path) => {
    return oldNewRoutingSchemaObj[key][path];
};

/* RN: return specific section data
param @key - String - desired key of oldNewRoutingSchemaObj
 */
const returnSectionPaths = key => {
    return oldNewRoutingSchemaObj[key];
};

/* RN: return old or new path string
param @key - String - desired key of oldNewRoutingSchemaObj
param @oldUrl - boolean - if true return oldUrl attribute if needed, otherwise return oldPath
param @detailId - string or number - replace id in path with real ID
 */
const kansoActive = true;
const returnCorrectPath = (
    key,
    oldUrl = false,
    detailId = null,
    section = null
) => {
    const kansoActive = SETTINGS.NEWUI;
    let data;
    //const kansoActive = window.location.href.indexOf('?newui') !== -1;
    if (!kansoActive) {
        if (oldUrl) data = oldNewRoutingSchemaObj[key]['oldUrl'];
        else data = oldNewRoutingSchemaObj[key]['oldPath'];
    } else data = oldNewRoutingSchemaObj[key]['newUrlPath'];

    if (detailId) data = data.replace(':id', detailId);
    if (section) data = data.replace(':section', section);

    return data;
};

const incidentDetailsPaths = [
    '/cases/:id/:page/:entity/history/:executionId',
    '/cases/:id/:page/:entity',
    returnCorrectPath('incidentsDetails')
];

const urlSeparator = SETTINGS.NEWUI ? '/' : '|';

export {
    dashboard,
    incidents,
    incidentsCreation,
    incidentsDetails,
    incidentsPlaybooks,
    incidentPlaybookExecution,
    incidentsObjects,
    incidentsAttachments,
    incidentsNotes,
    incidentsTasks,
    triage,
    triageDetails,
    entities,
    entitiesDetails,
    reports,
    reportsDetails,
    appCentral,
    playbooks,
    playbookExecutions,
    playbooksDetails,
    templates,
    templatesDetails,
    integrations,
    integrationsDetails,
    rules,
    rulesDetails,
    bridges,
    incidentsSettings,
    fields,
    fieldsDetails,
    incidentLabels,
    triageSettings,
    general,
    generalSystem,
    generalSettings,
    groups,
    groupsDetails,
    notifications,
    logo,
    preferences,
    oldNewRoutingSchemaObj,
    oldNewRoutingSchemaArray,
    incidentDetailsPaths,
    kansoActive,
    returnSpecificPath,
    returnSectionPaths,
    returnCorrectPath,
    urlSeparator,
    automationServicePlaybookExecution,
    appCentralExport,
    training
};
